interface MapFeature {
    properties?: {
        id?: unknown
        kind?: unknown
        sortKey?: unknown
    } | null
}

export const getTopOrderId = (features: MapFeature[]): string | undefined => {
    let topOrder: { id: string; sortKey: number } | undefined

    for (const { properties } of features) {
        if (
            properties?.kind !== 'order' ||
            typeof properties.id !== 'string' ||
            typeof properties.sortKey !== 'number'
        ) {
            continue
        }

        if (!topOrder || properties.sortKey > topOrder.sortKey) {
            topOrder = { id: properties.id, sortKey: properties.sortKey }
        }
    }

    return topOrder?.id
}
